import { SNumber, SString } from '@/common/model';
export class Delivery {
    id:SNumber
    name:SString // 交付项目名称
    finishDate: SString // 交付时间
    taskScaleType: SNumber // 0 | 1 | 2 | 3 - S, M, L, XL
    submitterId:SNumber // 提交人（创建人）
    projectId:SNumber //项目ID
    projectName:SString //项目名称
    members:SNumber[]=[] //执行人，第一个为队长
    taskTypeId: SNumber // 任务类型ID
    taskTypeName?: SString  // 任务类型名称
    morningMeetingId: SNumber // 晨会ID
    morningMeetingName?: SString  // 晨会名称
    taskStatusId: SNumber // 任务状态ID
    taskStatusName?: SString  // 任务状态名称
    attachmentUrl: SString // 附件地址
    remarks:SString
    lastOperator:SNumber  // 最后一个操作人员的ID
    createTime: SString // 提交时间
    updateTime: SString // 更新时间
}
  
export class DeliveryAE {
    id:SNumber
    name:SString // 交付项目名称
    finishDate: SString // 交付时间
    taskScaleType: SNumber // 0 | 1 | 2 | 3 - S, M, L, XL
    submitterId:SNumber // 提交人（创建人）
    projectId:SNumber //项目ID 
    members:SNumber[]=[] //执行人，第一个为队长
    taskTypeId: SNumber // 任务类型ID 
    morningMeetingId: SNumber // 晨会ID 
    taskStatusId: SNumber // 任务状态ID 
    attachmentUrl: SString // 附件地址 
    remarks:SString
}